<template>
    <div>
        <div v-if="loading">
            <img class="d-none d-lg-block" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/single-slider-D.svg" alt="" srcset="">
            <img class="d-none d-md-block d-lg-none" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/single-slider-D.svg" alt="" srcset="">
            <img class="d-block d-md-none" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/home-brands/single_slider-mobile.svg" alt="" srcset="">
        </div>
        <div v-if="!loading">
            <div id="content-section" v-if="pocs && pocs.length">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <h3 class="font-weight-bolder text-primary my-3 h5">
                        {{ renderHeadline(queryType)}}
                    </h3>
                    <div class="align-self-center d-flex flex-wrap pb-3 pb-lg-0">
                        <brandSeeAllBtn :settingsPerm="settingsPerm" :queryType="queryType" v-if="queryType !== 'ACADEMY'"/>
                        <brandSeeAllBtn 
                            v-if="queryType === 'ACADEMY'"
                            :settingsPerm="settingsPerm"
                            queryType="ACADEMY"
                            section="tutorials"
                            :label="$t('BrandComplex.seeMoreTutorials')"
                            class="mr-4"
                        />
                        <brandSeeAllBtn 
                            v-if="queryType === 'ACADEMY'"
                            :settingsPerm="settingsPerm"
                            queryType="ACADEMY"
                            section="courses"
                            :label="$t('BrandComplex.seeMoreCourses')"
                        />
                    </div>
                </div>
                <div class="splide newFeatureSlider mb-4" :class="randomId" :aria-label="`Slider for ${renderHeadline(queryType)}`">
                    <div class="splide__track mask-container">
                    <div class="splide__list">
                        <div class="splide__slide"
                        v-for="(singlePoc, i) in pocs" :key="i">
                        <singlePoc :singlePoc="singlePoc" :realUrl="singlePoc.realUrl" :isDevMioActive="isDevMioActive" :isDevmioNlActive="isDevmioNlActive" :showBadgeTooltip="showBadgeTooltip" :key="i" />
                        </div>
                    </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</template>

<script>
import Splide from "@splidejs/splide";
import helperfunctions from "../../services/helperfunctions.js";
import singlePoc from "./SinglePoc.vue";
import queryAndMutaionService from '../../services/queryAndMutaionService.js';
import brandSeeAllBtn from './brandSeeAllBtn.vue';


export default {
    name: "brandPocFeature",
    components: {
        singlePoc,
        brandSeeAllBtn
    },
    data() {
        return {
            randomId: this.generateRandomId(),
            brandSlug: false,
            page: 1,
            loading: false,
            error: false,
            result: null,
            pocs: [],
            splide: null,
            metaCount: 0,
            currentPage: 1,
            isDevMioActive: false,
            itemFetchCount: 0,
            isDevmioNlActive: false,
        };
    },
    props: {
      settingsPerm: Object,
      queryType: String,
      brandComplexSlug: String,
      pageSize: {
        type: Number,
        default: 7
      },
      perPageBreakpoints: {
        type: Object,
        default: () => ({
          default: 3,
          1600: 3,
          1280: 2,
          991: 2,
          767: 1,
          575: 1
        })
      },
      showBadgeTooltip: {
        type: Boolean,
        default: false
      }
    },
    created() {
        if (this.settingsPerm && this.settingsPerm.brandSlug) {
            this.brandSlug = this.settingsPerm.brandSlug;
        }
        if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
            this.isDevMioActive = this.settingsPerm.isDevMioActive;
        }
         if (this.settingsPerm && this.settingsPerm.isDevmioNlActive) {
            this.isDevmioNlActive = this.settingsPerm.isDevmioNlActive;
        }
        this.getPocForBrand();
    },
    methods: {

        getPocForBrand() {
            let pageSize = this.pageSize;
            queryAndMutaionService.getPocDataForBrands(this.brandSlug, this.queryType, this.page, pageSize).then((data) => {
                if (data && data.pieceOfContent.Meta && data.pieceOfContent.Meta.count) {
                    this.metaCount = data.pieceOfContent.Meta.count;
                }
                if (data && data.pieceOfContent && data.pieceOfContent.PieceOfContent && data.pieceOfContent.PieceOfContent.length) {
                    this.itemFetchCount = this.itemFetchCount + data.pieceOfContent.PieceOfContent.length;
                    this.result = data;
                    data.pieceOfContent.PieceOfContent.forEach((poc) => {
                        this.pocs.push({ ...poc, realUrl: helperfunctions.generateUrlForPocs(poc) });
                        this.mount_splide();
                    });
                }
                this.loading = false;
            }).catch((error) => {
                this.error = error;
                this.loading = false;
            });
            this.page++;
        },


        addMovedEventListener() {
            this.splide.on("moved", (newIndex) => {
            const lastCardIndex = newIndex + this.splide.options.perPage;
            if (this.itemFetchCount < this.metaCount && lastCardIndex >= this.itemFetchCount - 2) {
                this.getPocForBrand();
            }
            });
        },

        mount_splide: function () {
        let thiz = this;
        let padding = {
            right: "0rem",
            left: "0rem",
        };
        setTimeout(function () {
            if (thiz.pocs && thiz.pocs.length && thiz.pocs.length > 3) {
            padding = {
                right: "0rem",
                left: "0rem",
            };
            }
            if (!thiz.splide) {
                thiz.splide = new Splide('.'+thiz.randomId, {
                    classes: {
                        arrows : 'splide__arrows arrows',
                        arrow : 'splide__arrow arrow',
                        prev  : 'splide__arrow--prev prev',
                        next  : 'splide__arrow--next next',
                    },
                    perPage: thiz.perPageBreakpoints.default,
                    perMove: 1,
                    gap: '1rem',
                    rewind: false,
                    pagination: false,
                    padding:padding,
                    breakpoints: {
                        1600: {
                        perPage: thiz.perPageBreakpoints[1600],
                        },
                        1280: {
                        perPage: thiz.perPageBreakpoints[1280],
                        },
                        991: {
                        perPage: thiz.perPageBreakpoints[991],
                        },
                        767: {
                        perPage: thiz.perPageBreakpoints[767],
                        },
                        575: {
                        perPage: thiz.perPageBreakpoints[575],
                        padding: { left: '0rem', right: '5rem' },
                        arrows: false, 
                        start  : 0,
                        },
                    }, 
                });
                thiz.splide.mount();
                thiz.addMovedEventListener();
            } else {
            thiz.splide.refresh(); // Refresh the existing Splide instance
            }
          }, 100);
        },

        generateRandomId() {
            const randomSuffix = Math.random().toString(36).substring(2);
            return 'a' + randomSuffix; 
        },


        cuteventName(eventName) {
            if (eventName && eventName.length > 24) {
                eventName = eventName.slice(0, 24) + "...";
            }
            return eventName;
        },

        renderHeadline(queryType){
            let headline = '';
            switch(queryType) {
                case 'ISSUE':
                    headline = this.$t('BrandComplex.magazine');
                    break;
                case 'LIVE':
                    headline = this.$t('CategoryPage.liveEvents');
                    break;
                case 'ACADEMY':
                    headline = this.$t('CategoryPage.academy');
                    break;
                case 'READ':
                    headline = this.$t('CategoryPage.article');
                    break;
                case 'RHEINGOLD':
                    headline = this.$t('CategoryPage.conferences');
                    break;
                case 'CAMP':
                    headline = this.$t('CategoryPage.trainingsAndSeminars');
                    break;
                case 'LIVE_PAST':
                    headline = this.$t('recordingsFeature.LivePast');
                    break;
                default:    
                    headline = queryType;
            }
            return headline;
        }

    },
    
    
};


</script>

<style>

    .mask-container {
    position: relative;
    overflow: hidden;
    }

    .mask-container::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 94%;
    transform: translateX(-50%);
    width: 22%;
    background: linear-gradient(to right, transparent, white); 
    filter: blur(10px);
    }

    .prev {
        left: 68.5rem !important;
        background-color: transparent!important;
        outline: none !important;
    }
    
    .next {
        right: -0.5rem !important;
        background-color: transparent!important;
        outline: none !important;
    }
    
    .arrows {
        position: relative !important;
        top: -20px;
        outline: none !important;
    }

    
    .splide__arrow:focus-visible {
    outline: none !important;
    outline-offset: 0px;
    }

    .splide__arrow:disabled {
    opacity: 0.3 !important;
    }
    
    .newFeatureSlider .splide__arrow:disabled, .newFourFeatureSlider .splide__arrow:disabled {
    opacity: 0.3 !important;
    }
    @media screen and (max-width: 1679px) {
        .prev {
            left: 54rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 1359px) {
        .prev {
            left: 46rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 1199px) {
        .prev {
            left: 38rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
    @media screen and (max-width: 767px) {
        .prev {
            left: 26rem !important;
        }
        
        .next {
            right: 0rem !important;
        }
        
        .arrows {
            top: -20px;
        }
    }
</style>